"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterpriseQuoteService = void 0;
const service_1 = require("@phishtool/service");
const get_quote_pdf_1 = __importStar(require("~server/controllers/service/enterprise-quotes/get-quote-pdf"));
const middleware_1 = require("~server/middleware");
class EnterpriseQuoteService extends service_1.Service {
    constructor() {
        super(...arguments);
        this.getPDFURL = this.addSingletonFileQuery({
            controller: get_quote_pdf_1.default,
            schema: get_quote_pdf_1.GetQuotePDFRequestDataSchema,
            routeId: 'pdf',
            middleware: [middleware_1.rateLimitMiddleware],
        });
    }
}
exports.EnterpriseQuoteService = EnterpriseQuoteService;
